import { render, staticRenderFns } from "./OwnerBatchCreate.vue?vue&type=template&id=06cc084f&scoped=true"
import script from "./OwnerBatchCreate.vue?vue&type=script&lang=js"
export * from "./OwnerBatchCreate.vue?vue&type=script&lang=js"
import style0 from "./OwnerBatchCreate.vue?vue&type=style&index=0&id=06cc084f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc084f",
  null
  
)

export default component.exports